module.exports = __webpack_public_path__ + "static/img/img28.499913d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img28.png
// module id = TQzK
// module chunks = 1